<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="hljDailyProductionReport">
            <nav-bar-box :extr="navData"></nav-bar-box>
            <div class="accountsReceive">
                <timeNodeFiltering ref="timeNodeFiltering" @selectNodeCallback="getData"></timeNodeFiltering>
                <div class="main">
                    <div class="statisticsStyle1">
                        <div class="total">
                            <p class="describe iconfont sm-bag">
                                合计
                            </p>
                            <p class="num">
                                {{ totalVal.total_production }}
                            </p>
                        </div>
                        <div class="header">
                            <div class="item">
                                <p class="describe2">
                                    产成品
                                </p>
                                <p class="num2">
                                    {{ totalVal.finished_production }}
                                </p>
                            </div>
                            <div class="item">
                                <p class="describe2">
                                    二口料
                                </p>
                                <p class="num2">
                                    {{ totalVal.scrap_production }}
                                </p>
                            </div>
                            <div class="item">
                                <p class="describe2">
                                    尾料
                                </p>
                                <p class="num2">
                                    {{ totalVal.tailings_production }}
                                </p>
                            </div>
                        </div>
                        <div class="header">
                            <div class="item">
                                <p class="describe2">
                                    精粉用量
                                </p>
                                <p class="num2">
                                    {{ totalVal.inventory }}
                                </p>
                            </div>
                            <div class="item">
                                <p class="describe2">
                                    其他用量
                                </p>
                                <p class="num2">
                                    {{ totalVal.other_usage }}
                                </p>
                            </div>
                            <div class="item">
                                <p class="describe2">
                                    用电量
                                </p>
                                <p class="num2">
                                    {{ totalVal.electricity }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="statisticsStyle2">
                        <div class="item">
                            <p class="describe2">
                                精粉用量：
                            </p>
                            <p class="num2">
                                {{ totalVal.inventory }}
                            </p>
                        </div>
                        <div class="item">
                            <p class="describe2">
                                用电量：
                            </p>
                            <p class="num2">
                                {{ totalVal.electricity }}
                            </p>
                        </div>
                    </div>
                    <div class="chart-con">
                        <div id="recovery-chart"></div>
                    </div>
                    <div class="split"></div>
                    <div class="chart-con">
                        <div class="btn_box">
                            <template v-for="(item, index) in btns">
                                <van-button
                                    size="small"
                                    :key="`btn_${index}`"
                                    :class="{'xs_btn' : btnIndex === index}"
                                    @click="btnClick(item, index)"
                                >
                                    {{ item.name }}
                                </van-button>
                            </template>
                            <van-button size="small" @click="openDailyProductionReport()">
                                生产日报
                            </van-button>
                        </div>
                        <div id="balance-chart"></div>
                    </div>
                </div>
            </div>
        </div>
    </v-touch>
</template>

<script>
import timeNodeFiltering from '@/components/timeNodeFiltering/index.vue';
import { pieChart, lineChart } from '@/assets/js/charts';

export default {
    name: 'hlj-daily-production-report',
    components: { timeNodeFiltering },
    props: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'hlj-daily-production-report');
        }
        next();
    },
    data() {
        return {
            navData: {
                title: '黑龙江生产日报',
                leftText: '',
                rightText: '',
                leftArrow: true,
            },
            // 唤起日期选择的日期key
            dateKey: '',
            // showDatePop: false,
            listData: [], // 列表数据
            totalVal: {},
            tableData: [],

            btns: [{
                name: '生产量',
                key: 'scl',
            }, {
                name: '产出比',
                key: 'ccb',
            }, {
                name: '成球率',
                key: 'cql',
            }],
            btnIndex: 0,

            lineChartData: [],
        };
    },
    created() {},
    methods: {
        btnClick(item, index) {
            this.btnIndex = index;
            this.loadLineChart();
        },
        openDailyProductionReport() {
            this.$router.isBack = 2;
            const params = {
                tableData: JSON.stringify(this.tableData),
                date: this.$refs.timeNodeFiltering.startDate,
            };
            this.$router.replace({ name: 'hljDailyProductionReportList', params });
        },
        // 获取数据
        async getData(start_date, end_date) {
            this.$toast.loading({ overlay: true, duration: 0 });
            const res = await this.getDataList(start_date, end_date);
            if (res) {
                this.totalVal = res.total;
                this.tableData = res.details;
                this.lineChartData = res.days;
                const dataList = [
                    {
                        name: '产成品',
                        value: res.total.finished_production,
                    },
                    {
                        name: '二口料',
                        value: res.total.scrap_production,
                    },
                    {
                        name: '尾料',
                        value: res.total.tailings_production,
                    },
                ];
                const chartData = {
                    chartTitle: '统计图',
                    titlePosition: ['5', 0],
                    textStyle: {
                        fontSize: 18,
                    },
                    series: [{
                        top: 0,
                        radius: ['40%', '60%'],
                        center: ['50%', '50%'],
                        data: dataList,
                    }],
                };
                pieChart('recovery-chart', chartData);
                this.loadLineChart();
            }
            this.$toast.clear();
        },
        loadLineChart() {
            let ydata = [];
            let legendData = [];
            let grid = null;
            const xdata = this.lineChartData.map(item => item.report_date.substring(5, 10));
            if (this.btnIndex === 0) {
                ydata = [{
                    color: ['#FA8436', '#FA8436', '#fff'],
                    data: this.lineChartData.map(item => item.total_production),
                }];
            } else if (this.btnIndex === 1) {
                ydata = [{
                    color: ['#01C8FE', 'rgba(1, 200, 254, 0.16)', 'rgba(7, 109, 253, 0)'],
                    data: this.lineChartData.map(item => item.output_ratio),
                    markLine: {
                        symbol: ['none', 'arrow'],
                        label: {
                            position: 'end',
                        },
                        data: [{
                            silent: false,
                            lineStyle: {
                                type: 'dotted',
                                color: '#FA3934',
                                width: 2,
                            },
                            yAxis: 1,
                        }],
                    },
                }];
            } else if (this.btnIndex === 2) {
                legendData = ['一口料', '二口料', '尾料'];
                grid = {
                    top: 50,
                    left: 10,
                    right: 0,
                    bottom: 15,
                    containLabel: true,
                };
                ydata = [{
                    name: '一口料',
                    color: ['#01C8FE', 'rgba(1, 200, 254, 0.16)', 'rgba(7, 109, 253, 0)'],
                    data: this.lineChartData.map(item => item.output_ratio_finished),
                }, {
                    name: '二口料',
                    color: ['#05DEBF', 'rgba(5, 222, 191, 0.20)', 'rgba(4, 162, 220, 0)'],
                    data: this.lineChartData.map(item => item.output_ratio_scrap),
                }, {
                    name: '尾料',
                    color: ['#5EC875', 'rgba(94, 200, 117, 0.16)', 'rgba(213, 201, 64, 0)'],
                    data: this.lineChartData.map(item => item.output_ratio_tailings),
                }];
            }
            const chartData = {
                grid,
                legendX: '10',
                xdata,
                borderColor: 'rgba(133,133,133,0.2)',
                fontColor: '#979EA7',
                legendData,
                ydata,
            };
            lineChart('balance-chart', chartData);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },

        // 获取数据
        getDataList(start_date, end_date) {
            return this.$axios.$get(`/interfaceApi/report/report/hlj/production_day_report/${start_date}?end_date=${end_date}`, { defEx: true });
        },
    },
};
</script>
<style lang="stylus" scoped>
.accountsReceive
    background #fff
    width 100%
    height calc(100vh - 70rpx)
    overflow-y: scroll
    .charts_header
        margin 12rpx 30rpx
        .van-tabs__nav
            margin 0
    .search-conditions-con
        padding 10rpx
    .main
        .statisticsStyle1
            margin: 15rpx 15rpx 5rpx
            border-radius 4rpx
            background url(../../../images/fundBalanceDaily/bg@2x.png) right bottom no-repeat, repeating-linear-gradient(to left, #F79187, #EA5D5D)
            background-size: auto 90%
            .total
                height 42rpx
                line-height 42px
                color #fff
                display flex
                border-bottom 1px solid rgba(255,255,255,0.2)
                padding 0 20rpx
                .num
                    font-size 22rpx
                    margin-left 10rpx
                .describe
                    font-size 16rpx
                    &:before
                        margin-right 5rpx
            .header
                display flex
                justify-content: space-between
                flex-wrap: wrap;
                margin-top 2rpx
                padding 0 20rpx
                .item
                    width: 33.3%
                    padding 3rpx 0 5rpx 0
                    color #fff
                    .num2
                        font-size 22rpx
                        margin-top 6rpx
                    .describe2
                        font-size 14rpx
                        margin-bottom 3rpx
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                        line-height 25rpx
        .statisticsStyle2
            margin:  0 15rpx 15rpx
            display flex
            .item
                flex 1
                height: 40rpx;
                line-height 40rpx
                border-radius: 4px;
                border: 1px solid #FFFFFF;
                display flex
                justify-content center
                color #fff
                &:nth-of-type(1)
                    margin-right 5rpx
                    background: linear-gradient(270deg, #918F9E 0%, #6D6B7B 100%);
                &:nth-of-type(2)
                    background: linear-gradient(261deg, #A48171 0%, #7C5446 100%);
                .describe2
                    font-size 12rpx
                .num2
                    font-size 20rpx
        .split
            background #F0F0F0
            height 15rpx
        .chart-con
            padding 10rpx
            position relative
            .btn_box
                text-align: right
                button
                    border-radius: 4rpx
                    padding 0 12rpx
                    margin-left 5rpx
                    color #E93743
                    border: 1px solid #E93743;
                .xs_btn
                    border: none
                    background: linear-gradient(138deg, #EB6348 0%, #E93543 100%);
                    color #fff
            h4
                margin 10rpx 0
            #balance-chart
                height 260rpx
            #recovery-chart
                height 265rpx
</style>
